var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCitadelLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 58,
    viewBox: "0 0 42 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23145 24.4309H33.1547L30.2058 45.5674H11.1854L8.23145 24.4309Z",
    fill: "#00EEE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.154 24.4314L41.3524 12.1375L36.108 45.5679H30.2051L33.154 24.4314Z",
    fill: "#16E1CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.1375L8.23123 24.4314L11.1852 45.5679H5.28236L0 12.1375Z",
    fill: "#0ACA9D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6765 0.302734L41.3529 12.136L33.1545 24.4305H8.23124L0 12.136L20.6765 0.302734Z",
    fill: "#6BF6FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6949 57.3027L11.1847 45.5676L30.2051 45.5676L20.6949 57.3027Z",
    fill: "#0ACA9D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6953 57.3027L5.28224 45.5676L11.1851 45.5676L20.6953 57.3027Z",
    fill: "#019B76"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6953 57.3027L36.1084 45.5676L30.2047 45.5676L20.6953 57.3027Z",
    fill: "#019B76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitadelLogo);
export default __webpack_public_path__ + "static/media/citadel-logo.4e99f6b68a06ebaf2b3f674e7d1098ea.svg";
export { ForwardRef as ReactComponent };